import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.object.assign.js";
import { isString } from 'lodash-es';
import hash from '@/shared/hash';
import * as userService from '@/services/user';
import { useUTMStore } from './utm';
export var useUserStore = defineStore('user', {
    state: function() {
        return {
            // userInfo: null,
            commonData: {
                utdKey: '',
                userKey: '',
                appTitle: 'orale',
                userSourceStr: '',
                softwareBuild: '1.0.4',
                appStream: '',
                sysInfo: '',
                countryApp: 'mex',
                appKey: 'com.mexorale.credito.seguridad.app',
                userPlatType: 'H5',
                machineType: ''
            },
            token: null,
            phone: null,
            name: null,
            identifier: null,
            firstLogin: null,
            // appVersion: null,
            blackbox: null,
            // utdKey: null,
            smsPermission: 0,
            gaid: null,
            appsflyerId: null,
            adjustChannel: null
        };
    },
    getters: {
        isLogin: function(state) {
            return isString(state.token) && state.token.length > 0;
        },
        isNotLogin: function() {
            return !this.isLogin;
        }
    },
    actions: {
        update: function(payload) {
            this.$patch(payload);
            if (payload.phone) {
                this.$patch({
                    identifier: hash(payload.phone)
                });
            }
            if (payload.commonData) {
                Object.assign({}, this.$state.commonData, payload.commonData);
            }
        },
        logout: function() {
            return _async_to_generator(function() {
                return _ts_generator(this, function(_state) {
                    this.$reset();
                    return [
                        2
                    ];
                });
            }).apply(this);
        },
        login: function(payload) {
            return _async_to_generator(function() {
                var utmStore, result;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            utmStore = useUTMStore();
                            return [
                                4,
                                userService.login(_object_spread({
                                    userSourceStr: utmStore.source,
                                    streamFlow: utmStore.channel
                                }, payload))
                            ];
                        case 1:
                            result = _state.sent();
                            // const identifier = makeIdentifier(payload.phone);
                            // if (this.identifier !== identifier) {
                            //   await this.logout();
                            // }
                            this.update({
                                token: result.coinMarker,
                                phone: result.mobileNumber,
                                firstLogin: !!result.initialAccess,
                                commonData: _object_spread({}, this.commonData, result)
                            });
                            return [
                                2
                            ];
                    }
                });
            }).apply(this);
        },
        /**
     * Synchronize app login
     */ syncLoginByApp: function(payload) {
            var _payload_phone;
            var identifier = hash((_payload_phone = payload.phone) !== null && _payload_phone !== void 0 ? _payload_phone : '');
            if (this.identifier !== identifier) {
                this.logout();
            }
            this.update({
                token: payload.token,
                phone: payload.phone
            });
        },
        sendCaptcha: /**
     * Send SMS verification code
     */ function(payload) {
            return _async_to_generator(function() {
                var utmStore;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            utmStore = useUTMStore();
                            return [
                                4,
                                userService.sendCaptcha(_object_spread({
                                    userSourceStr: utmStore.source,
                                    codeType: 'mobile_login'
                                }, payload))
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    },
    persist: {
        paths: [
            // 'userInfo',
            'commonData',
            'token',
            'phone',
            'name',
            'identifier',
            'firstLogin',
            // 'appVersion',
            'blackbox',
            // 'utdKey',
            'smsPermission',
            'gaid',
            'appsflyerId',
            'adjustChannel'
        ]
    }
});
